<template>
  <LazyAutocomplete
    :value="value"
    :label="label"
    :items.sync="localItems"
    :placeholder="placeholder"
    :total-items="totalItems"
    :color-fn="colorFn"
    no-filter
    dense
    outlined
    :multiple-select="multipleSelect"
    :disabled="disabled"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :append="append"
    :component-name="componentName"
    @input="$emit('input', $event)"
    @getItems="$emit(`getItems`, $event)"
    @update:items="$emit('update:items', localItems)"
    @add="
      (id) => {
        $emit('add', id);
      }
    "
  />
</template>

<script>
import LazyAutocomplete from "./story/LazyAutocomplete.vue";
export default {
  components: {
    LazyAutocomplete,
  },
  props: {
    value: {
      type: [Object, Array],
    },
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    componentName: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    colorFn: {
      type: Function,
      default: () => "",
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
    append: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localItems: [],
  }),
  watch: {
    items(val) {
      this.localItems = val;
    },
  },
};
</script>
